import Vue from 'vue';

const getDefaultItem = () => ({
  isAnnual: true,
  serviceAgreementAccepted: false,
  userCount: 0,
});

export const getDefaultState = () => ({
  item: getDefaultItem(),
  previousItem: getDefaultItem(),
});

const copyValues = ({ commit }, fromItem, toName) => {
  commit(`SET_${toName}_IS_ANNUAL`, fromItem.isAnnual);
  commit(`SET_${toName}_USER_COUNT`, fromItem.userCount);
};

export default {
  namespaced: true,
  state: {
    ...getDefaultState(),
  },
  actions: {
    setIsAnnual({ commit }, isAnnual) {
      commit('SET_ITEM_IS_ANNUAL', isAnnual);
    },
    setServiceAgreementAccepted({ commit }, serviceAgreementAccepted) {
      commit('SET_ITEM_SERVICE_AGREEMENT_ACCEPTED', serviceAgreementAccepted);
    },
    setUserCount({ commit }, userCount) {
      commit('SET_ITEM_USER_COUNT', userCount);
    },
    setPreviousToItem(context) {
      copyValues(context, context.state.item, 'PREVIOUS');
    },
    resetItemToPrevious(context) {
      copyValues(context, context.state.previousItem, 'ITEM');
    },
  },
  getters: {
    getIsAnnual(state) {
      return state.item.isAnnual;
    },
    getServiceAgreementAccepted(state) {
      return state.item.serviceAgreementAccepted;
    },
    getUserCount(state) {
      // This is to account for userCount being NaN
      return state.item.userCount || 0;
    },
  },
  mutations: {
    SET_ITEM_IS_ANNUAL(state, isAnnual) {
      Vue.set(state.item, 'isAnnual', isAnnual);
    },
    SET_ITEM_SERVICE_AGREEMENT_ACCEPTED(state, serviceAgreementAccepted) {
      Vue.set(state.item, 'serviceAgreementAccepted', serviceAgreementAccepted);
    },
    SET_ITEM_USER_COUNT(state, userCount) {
      Vue.set(state.item, 'userCount', userCount);
    },
    SET_PREVIOUS_IS_ANNUAL(state, isAnnual) {
      Vue.set(state.previousItem, 'isAnnual', isAnnual);
    },
    SET_PREVIOUS_USER_COUNT(state, userCount) {
      Vue.set(state.previousItem, 'userCount', userCount);
    },
  },
};
